import { type App } from 'vue'
import { action, _pageLevelData } from './api'

interface TrackingData {
  event: string
  fn: (el: unknown) => void
  type: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  routeProps: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: any
}

export default {
  install(app: App) {
    const map: WeakMap<object, TrackingData> = new WeakMap()

    function fireEvent(el: HTMLElement) {
      const data = map.get(el)
      if (!data) return

      action(data.event, {
        ..._pageLevelData.value,
        ...data.routeProps,
        ...data.props,
      })
    }

    app.directive('track', {
      beforeMount(el, binding) {
        const data = map.get(el) ?? ({} as TrackingData)
        const route = app.__router.currentRoute.value
        data.event = binding.value
        data.fn = fireEvent.bind(null, el)
        data.type = binding.arg ?? 'click'
        data.routeProps = {
          page: route?.meta.pageName,
          ...route?.params,
        }
        if (data.type !== 'appear') {
          el.addEventListener(data.type, data.fn)
        }
        map.set(el, data)
      },
      mounted(el, binding) {
        if (binding.arg === 'appear') {
          setTimeout(fireEvent.bind(null, el), 500)
        }
      },
      updated(el, binding) {
        const data = map.get(el) ?? ({} as TrackingData)
        data.event = binding.value
        map.set(el, data)
      },
      unmounted(el) {
        const data = map.get(el)
        if (!data) return
        el.removeEventListener(data.type, data.fn)
        map.delete(el)
      },
    })

    app.directive('track-props', {
      beforeMount(el, binding) {
        const data = map.get(el) ?? ({} as TrackingData)
        data.props = binding.value
        map.set(el, data)
      },
      updated(el, binding) {
        const data = map.get(el) ?? ({} as TrackingData)
        data.props = binding.value
        map.set(el, data)
      },
    })
  },
}
